import React from "react";
import { Stack, Typography, Button, Chip } from "@mui/material";
import BannerPerson from "../../../assets/Images/Person1.png";
import StarIcon from "@mui/icons-material/Star";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Link, useNavigate, useParams } from "react-router-dom";
import { countries } from "country-data";
import "../../../App.css";

const UserHeader = ({ name, country, picture, reviews, rating }) => {
  let { id } = useParams();
  const navigate = useNavigate();
  const personRating = 3.5;
  const isVerified = true;
  const chatButtonHandler = () => {
    navigate("/chat");
  };
  const sendDetailsButtonHandler = () => {
    navigate(`/personalised-request/${id}`);
  };
  return (
    <div
      style={{
        width: "100%",
        height: "200px",
        backgroundColor: "rgba(255, 109, 28, 0.1)",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={4}
        style={{ width: "90%", margin: "auto" }}
      >
        <div className="mt-7">
          <img
            src={picture}
            alt="Banner Person"
            style={{
              width: "150px",
              height: "150px",
              border: "4px solid #FFFFFF",
              borderRadius: "50%",
            }}
          />
        </div>
        <div style={{ width: "50%" }} className="ml-16">
          <Typography
            variant="h5"
            component="div"
            color="black"
            style={{ textTransform: "capitalize" }}
          >
            {name}
          </Typography>
          <Typography variant="subtitle1" className="ammanat-darker-gray">
            {countries[country].name}
          </Typography>
          <Stack
            style={{
              padding: "3px",
              borderRadius: "4px",
              backgroundColor: "rgba(52, 168, 83, 0.3)",
              width: "10%",
            }}
            spacing={1}
            direction="row"
            alignItems="center"
            className="mb-5"
          >
            <StarIcon
              style={{
                height: "18px",
                width: "18px",
                color: "rgba(52, 168, 83, 1)",
              }}
            />
            <Typography style={{ color: "rgba(52, 168, 83, 1)" }}>
              {rating}
            </Typography>
          </Stack>
        </div>
        <div>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Button
              variant="outlined"
              className="default-border default-color"
              style={{ textTransform: "capitalize" }}
            >
              Share
            </Button>
            <Button
              variant="contained"
              className="primary-button"
              style={{ textTransform: "capitalize" }}
              onClick={sendDetailsButtonHandler}
            >
              Send Details
            </Button>
            <div
              className="default-border default-color icon-button"
              style={{ cursor: "pointer" }}
              onClick={chatButtonHandler}
            >
              <ChatOutlinedIcon />
            </div>
          </Stack>
        </div>
      </Stack>
    </div>
  );
};

export default UserHeader;
